<div class="modal-header">
    <h4 class="modal-title">Puantaj {{data.row ? 'Güncelle' : 'Ekle'}}</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="personPointForm">
         <div class="row">
            <div class="col-6" *ngIf="personPointForm.value.status == 3 ||personPointForm.value.status == 4">
                <label for="leaveDay">Ek Mesai Saati</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="number" class="form-control" id="name" formControlName="overtimeHours" />
                    </div>
                </div>
            </div>

            <div class="col-6" *ngIf="personPointForm.value.status == 3 ||personPointForm.value.status == 4">
                <label for="leaveDay">Ek Mesai Oranı</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="number" class="form-control" id="name" formControlName="workRate" />
                    </div>
                </div>
            </div>

            <div class="col-6">
                <label for="startDate">Mesai Başlangıç Saati</label>
                <div class="form-group">
                    <ng2-flatpickr [config]="dateTimeEndOptions" name="dateTime" formControlName="workDate"
                        [setDate]="date"></ng2-flatpickr>
                </div>
            </div>

            <div class="col-6">
                <label for="startDate">Mesai Bitiş Saati</label>
                <div class="form-group">
                    <ng2-flatpickr [config]="dateTimeEndOptions" name="dateTime" formControlName="endDate"
                        [setDate]="date2"></ng2-flatpickr>
                </div>
            </div>

            <div class="col-6" [ngClass]="{'col-12': personPointForm.value.status == 3 || personPointForm.value.status == 4}">
                <label for="status">Durum</label>
                <div class="form-group">
                    <ng-select [items]="statusList" formControlName="status" placeholder="Durum seç" bindValue="id" bindLabel="name"></ng-select>
                </div>
            </div>
            

        </div> 
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">Hayır</button>
    <button type="button" class="btn btn-success" [disabled]="!isFormValid()" (click)="onSumbit()">{{data.row ?
        'Güncelle' : 'Kaydet'}}</button>
</div>